import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Icon from '../../components/Icon'
import Image from '../../components/Image'
import DemoWrapper from '../../components/DemoWrapper'
import Grid from '../../components/Grid'

import iconsTypo from '../../assets/images/brandbook/icons-typo.svg'
import iconTypo from '../../assets/images/brandbook/typography.svg'
import iconBalance from '../../assets/images/brandbook/balance1.svg'

export const path = '/brandbook/icons'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Icons</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">

    <Section>

      <Grid grid="1-2">
        <></>
        <>
          <p>Our icon style is built to match the shapes of the Karelia typeface. It uses a combination of sharp edges and rounded corners. </p>
        </>
      </Grid>
      </Section>

      <Section>

        <Grid>
          <Image imageUrl={iconTypo} aspect="1/1" />
          <Image imageUrl={iconBalance} aspect="1/1" />
        </Grid>

      </Section>

      <img src={iconsTypo} alt="" />


      <Section>




        <Grid grid="1-2">
          <></>
          <>
            <h2>Current icon set</h2>
            <p>By default stroke width is set to 3px but it should be adjusted and paired with typography size and context. New icons are built when needed. </p>
          </>
        </Grid>

        <Grid grid="6">
          <DemoWrapper aspect="1/1" description="Menu" center>
            <Icon icon="menu" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Download" center>
            <Icon icon="download" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Speakers" center>
            <Icon icon="speakers" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Sensor" center>
            <Icon icon="sensor" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Settings" center>
            <Icon icon="settings" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Music" center>
            <Icon icon="music" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Volume" center>
            <Icon icon="volume" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="Users" center>
            <Icon icon="users" />
          </DemoWrapper>

          <DemoWrapper aspect="1/1" description="External link" center>
            <Icon icon="externalLink" />
          </DemoWrapper>

        </Grid>
      </Section>

      <br />
    </Container>
    </div>
    )
  }
